import api from "../../api";

class BackendUserAPI {
    static list(payload) {
        const params = {
            page: payload?.page,
            take: payload?.take,
        };

        Object.keys(payload.filter ?? {}).forEach((k) => {
            params[`filter[${k}]`] = payload.filter[k] ? payload.filter[k] : undefined;
        });

        return api.get("/backend/users", { params });
    }

    static get(id) {
        return api.get(`/backend/users/${id}`);
    }

    static update(id, payload = {}) {
        return api.patch(`/backend/users/${id}`, payload);
    }

    static delete(id) {
        return api.delete(`/backend/users/${id}`);
    }
}

export default BackendUserAPI;
